import { z } from "zod";

export const roadTypeEnum = z.enum(["Upbound", "Downbound", "Both"]);

export type RoadType = z.infer<typeof roadTypeEnum>;
